<template>
   <img src="@images/avatar_placeholder.jpg" class="img-fluid">
</template>
<script>
export default { }
</script>
